import { parseRichText } from '@libs/contentful';

import { type LivePetContent } from '@/entities/live-pet-content';
import { BaseDrawer } from '@/shared/ui';

type LivePetDrawerProps = LivePetContent & {
    open: boolean;
    onCloseAction: () => void;
};

export const LivePetDrawer = ({ open, header, body, onCloseAction }: LivePetDrawerProps) => {
    return (
        <BaseDrawer isOpen={open} title={header} onCloseAction={onCloseAction} testId="specialty-info-drawer">
            {body && parseRichText(body)}
        </BaseDrawer>
    );
};
